import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import invtService from "../services/inventory.Service"; 

export const inventoryGeneral = createAsyncThunk(
  "inventory/general",
  async (formData) => {
    const data = await invtService.general(formData);
    return data  
  }
);
export const inventoryManufacturing = createAsyncThunk(
  "inventory/manufacturing",
  async (formData) => {
    const data = await invtService.manufacturing(formData);
    return data  
  }
);

export const uomByInventoryId = createAsyncThunk(
  "bom/byInventoryId",
  async (inventoryId) => {
    const data = await invtService.uomByInventoryId(inventoryId);
    return data  
  }
);

export const inventoryBulkProcessMapping = createAsyncThunk(
  "inventory/bulk-process-mapping",
  async (formData) => {
    const data = await invtService.bulkProcessMapping(formData);
    return data  
  }
);
export const inventoryGst = createAsyncThunk(
  "inventory/gst",
  async (formData) => {
    const data = await invtService.gst(formData);
    return data  
  }
);
export const inventoryTds = createAsyncThunk(
  "inventory/tds",
  async (formData) => {
    const data = await invtService.tds(formData);
    return data  
  }
);
export const inventoryTcs = createAsyncThunk(
  "inventory/tcs",
  async (formData) => {
    const data = await invtService.tcs(formData);
    return data  
  }
);

export const inventoryList = createAsyncThunk(
  "inventory/list",
  async (params) => {
    const data = await invtService.inventoryList(params);
    return data  
  }
);

const initialState = {
  list:[],
  userInventoryData:[],
  uomList:[],
  inventoryId:"",
  success:false,
  error:false,
  loading:false,
  message:""
}

const InventorySlices = createSlice({
  name:"Inventory",
  initialState,
  reducers:{
    reset:() => initialState  
  },
  extraReducers:{
    [inventoryGeneral.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [inventoryGeneral.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.message;    
      }else{
        state.inventoryId = action.payload.inventoryId
        state.success = action.payload.message; 
      }
    },
    [inventoryGeneral.rejected] : (state, action) => {
      state.loading = false;
      state.error = action.payload.message
    },

    [inventoryManufacturing.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [inventoryManufacturing.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.message;    
      }else{
        state.success = action.payload.message; 
      }
    },
    [inventoryManufacturing.rejected] : (state, action) => {
      state.loading = false;
      state.error = action.payload.message
    },

    [inventoryBulkProcessMapping.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [inventoryBulkProcessMapping.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.message;    
      }else{
        state.success = action.payload.message; 
      }
    },
    [inventoryBulkProcessMapping.rejected] : (state, action) => {
      state.loading = false;
      state.error = action.payload.message
    },
        
    [inventoryList.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [inventoryList.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.message;    
      }else{
        state.success = action.payload.message; 
        state.list  = action.payload.data
      }
    },
    [inventoryList.rejected] : (state) => {
      state.loading = false;
    },

    [uomByInventoryId.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [uomByInventoryId.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.error;    
      }else{
        state.uomList = action.payload.data; 
      }
    },
    [uomByInventoryId.rejected] : (state) => {
      state.loading = false;
    },

    [inventoryBulkProcessMapping.pending] : (state) => {
      state.loading = true
      state.error = false
      state.success = false
    },
    [inventoryBulkProcessMapping.fulfilled] : (state, action) => {
      state.loading = false;
      if(!action.payload.success){
        state.error = action.payload.message;    
      }else{
        state.success = action.payload.message; 
      }
    },
    [inventoryBulkProcessMapping.rejected] : (state, action) => {
      state.loading = false;
      state.error = action.payload.message
    },
  }
})

export const { reset } = InventorySlices.actions;

export default InventorySlices.reducer;